import styled from "styled-components";

export const IndexFaqComponentMainDiv = styled.section`
  > div {
    display: flex;
    gap: 0;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .faq-container {
    display: flex;
    width: 100%;
    gap: 60px;
    max-width: 1140px;
    flex: 1;
  }
  .faq-left {
    display: flex;
    flex-flow: column;
    gap: 24px;
    max-width: 441px;
  }
  .faq-header {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .faq-text-container {
    max-width: 331px;
    > h2 {
    }
    h4 {
      padding: 0;
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.6em;
      color: white;
      font-family: "Inter", "Inter Placeholder", sans-serif;
    }
    > p {
      font-size: 16px;
      font-weight: 400;
      line-height: 1.4em;
    }
  }
  .faq-description-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
  .faq-button-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 170px;
  }

  .faq-questions-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    gap: 12px;
  }
`;
interface IndexFaqComponentFaqItemProp {
  isOpened: boolean;
}

export const IndexFaqComponentFaqItem = styled.div<IndexFaqComponentFaqItemProp>`
  cursor: pointer;
  > div {
    border: 1px solid rgb(255 255 255 / 10%);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
        transition: all 0.5s ease;

    gap: ${(p) => (p.isOpened ? "16px" : "0")};
    padding: 16px;
  }
  .faq-item-header {
    display: flex;
    gap: 24px;
    align-items: center;
    user-select: none;
    justify-content: space-between;
  }
  .faq-text-wrapper {
    transition: all 0.4s;
    &:hover {
      opacity: ${(p) => (p.isOpened ? " 1" : "  0.5")};
    }
    > h3 {
      font-size: 26px;
      font-weight: 500;
      margin: 0;
      padding: 0;
    }
    > p {
      font-size: 18px;
      opacity: 0.8;
      font-weight: 400;
      line-height: 1.5em;
    }
  }
  .faq-cross-icon-contaner {
    width: 20px;
    height: 20px;
    &:before {
      content: "";
      width: 100%;
      height: 2px;
      background: white;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0.7;
    }
    > div {
      width: 100%;
      height: 20px;

      &:before {
        content: "";
        width: 100%;
        height: 2px;
        background: white;
        position: absolute;
        transition: all 0.42s;
        top: 50%;
        transform: translateY(-50%)
          ${(p) => (!p.isOpened ? " rotateZ(90deg)" : " rotateZ(0deg)")};
        opacity: 0.7;
      }
    }
  }
  .faq-text-boottom-text-contaner {
    transition: all 0.5s ease;
    height:100%;

    max-height: ${(p) => (p.isOpened ? " 1100px" : "0")};
    overflow:hidden;
    >div{
    opacity: ${(p) => (p.isOpened ? " 1" : "0")};}
  }
`;
